import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'ticketButton';
  const widgetOpts = ticketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
      } else {
        createCustomTicketBtn(data.items[0]);
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData;

    $widget.replaceWith(`
      <a class="ticket-button" href="${URL}" ${isLocalUrl(URL) ? '' : 'target="_blank"'} aria-label="${Title}" tabindex="0">
        <span class="tkt-icon"></span>
        <span class="tkt-text">${Title}</span>
      </a>
      `);
  }
}
